import { render } from "./Partecipation.vue?vue&type=template&id=fa6f62e2&scoped=true"
import script from "./Partecipation.vue?vue&type=script&lang=js"
export * from "./Partecipation.vue?vue&type=script&lang=js"

import "./Partecipation.vue?vue&type=style&index=0&id=fa6f62e2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6f62e2"]])

export default __exports__